import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Palette, FileText, Globe, Image as ImageIcon, Video, Radio } from 'lucide-react';
export function AdvertisingPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-70">
      <Header data-id="element-71" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-72">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-74">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-75" />
            Back to Home
          </a>

          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-76">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-77">
              Twice Bourne Advertising
            </h1>
            <p className="text-2xl text-slate-300" data-id="element-78">
              Your one-stop creative centre
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-79">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-80">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-81">
                <Palette className="w-7 h-7" data-id="element-82" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-83">
                Logo & Branding
              </h3>
              <p className="text-slate-400" data-id="element-84">
                Crafting unique brand identities that stand out.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-85">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-86">
                <FileText className="w-7 h-7" data-id="element-87" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-88">
                Print Design
              </h3>
              <p className="text-slate-400" data-id="element-89">
                Business cards, flyers, and physical marketing materials.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-90">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-91">
                <Globe className="w-7 h-7" data-id="element-92" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-93">Web Design</h3>
              <p className="text-slate-400" data-id="element-94">
                Beautiful, responsive websites tailored to your business.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-95">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-96">
                <ImageIcon className="w-7 h-7" data-id="element-97" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-98">
                Graphic Design
              </h3>
              <p className="text-slate-400" data-id="element-99">
                Custom graphics for social media and digital campaigns.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-100">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-101">
                <Video className="w-7 h-7" data-id="element-102" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-103">Video Ads</h3>
              <p className="text-slate-400" data-id="element-104">
                Compelling video content that drives engagement.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-105">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-106">
                <Radio className="w-7 h-7" data-id="element-107" />
              </div>
              <h3 className="text-xl font-bold text-white mb-2" data-id="element-108">Radio Ads</h3>
              <p className="text-slate-400" data-id="element-109">
                Professional audio production for radio broadcasting.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-110" />
    </div>;
}